// TestContent.js
import React from 'react';

const Lessons = () => {
  return (
    <div>
      <h1>Lessons</h1>
      <p>This content is coming from the TestContent component.</p>
    </div>
  );
};

export default Lessons;
